module.exports = __webpack_public_path__ + "img/my-uid.e3f0033.png";